import React from 'react'
import { Link } from 'gatsby'

export default props => (
	<div className="prev-next-wrap">
		<div className="row">
			{props.prev && (
				<div className="col-md-6">
					<div className="content-wrap">
						<Link to={props.prev.fields.slug} className="nav-text">
							Previous post
						</Link>
						<h2 className="title h4">
							<Link to={props.prev.fields.slug}>
								{props.prev.frontmatter.title}
							</Link>
						</h2>
						<time
							className="date"
							datetime={props.prev.frontmatter.ymdDate}
							title={props.prev.frontmatter.dmyDate}
						>
							{props.prev.frontmatter.mdyDate}
						</time>
					</div>
				</div>
			)}
			{props.next && (
				<div className="col-md-6">
					<div className="content-wrap">
						<Link to={props.next.fields.slug} className="nav-text">
							Next post
						</Link>
						<h2 className="title h4">
							<Link to={props.next.fields.slug}>
								{props.next.frontmatter.title}
							</Link>
						</h2>
						<time
							className="date"
							datetime={props.next.frontmatter.ymdDate}
							title={props.next.frontmatter.dmyDate}
						>
							{props.next.frontmatter.mdyDate}
						</time>
					</div>
				</div>
			)}
		</div>
	</div>
)
